import { apiPost, apiGet } from './utils';
import type { User } from '../types';

export interface LoginResponse {
  token: string;
  user: User;
}

export interface RegisterResponse {
  token: string;
  user: User;
}

export const authApi = {
  async login(email: string, password: string): Promise<LoginResponse> {
    return apiPost<LoginResponse>('/auth/login', { email, password });
  },

  async register(
    email: string,
    password: string,
    firstName?: string,
    lastName?: string
  ): Promise<RegisterResponse> {
    return apiPost<RegisterResponse>('/auth/register', {
      email,
      password,
      first_name: firstName,
      last_name: lastName,
    });
  },

  async logout(): Promise<void> {
    return apiPost('/auth/logout');
  },

  async me(): Promise<User> {
    return apiGet<User>('/auth/me');
  },

  async getRoles(): Promise<Array<{ role: string; uuid: string }>> {
    return apiGet<Array<{ role: string; uuid: string }>>('/users/roles');
  },

  async requestPasswordReset(email: string): Promise<{ message: string }> {
    return apiPost('/auth/password/reset-request', { email });
  },

  // key and uuid come from the emailed link: /password/set/:key/:uuid
  async resetPassword(
    key: string,
    uuid: string,
    password: string
  ): Promise<{ message: string }> {
    return apiPost('/auth/password/reset', { key, uuid, password });
  },

  async changePassword(
    currentPassword: string,
    password: string
  ): Promise<{ message: string }> {
    return apiPost('/auth/password/change', {
      current_password: currentPassword,
      password,
    });
  },
};
